const configFunction = (which) => {
  let config = "";
  let baseUrlStg = "https://cogaiph-eus-stg-location.azurewebsites.net/api";
  let baseUrlProd = "https://cogaiph-eus-prod-location.azurewebsites.net/api";
  if (which === "stg") {
    return (config = {
      transactions: `https://nitrogen-eus-stg-transactions.azurewebsites.net/api`,
      invalidTypes: `https://nitrogen-eus-stg-transactions.azurewebsites.net/api/invalid-types?`,
      products: `https://nitrogen-eus-stg-products.azurewebsites.net/api/products`,
      skus: `https://nitrogen-eus-stg-products.azurewebsites.net/api/skus`,
      users: `https://nitrogen-eus-stg-users.azurewebsites.net/api/users`,
      raffle: `https://nitrogen-eus-stg-raffle.azurewebsites.net/api/draw`,
      winners: `https://nitrogen-eus-stg-raffle.azurewebsites.net/api/winners`,
      prep: `https://nitrogen-eus-stg-raffle.azurewebsites.net/api/prep`,
      login: `https://nitrogen-eus-stg-accounts.azurewebsites.net/api/login`,
      accounts: `https://nitrogen-eus-stg-accounts.azurewebsites.net/api/accounts`,
      txnstats: `https://nitrogen-eus-stg-stats.azurewebsites.net/api/stats`,
      productstats: `https://nitrogen-eus-stg-itemstats.azurewebsites.net/api/itemstats`,
      responder: `https://nitrogen-eus-stg-responder.azurewebsites.net/api/responder`,
      fraud: `https://nitrogen-eus-stg-transactions.azurewebsites.net/api/fraud/duplicate`,
      export: `https://nitrogen-eus-stg-exporter.azurewebsites.net/api/export/weekly`,
      redeem: `https://nitrogen-eus-stg-redeem.azurewebsites.net/api/redeemhistory`,
      gCashBalance: `https://nitrogen-eus-stg-redeem.azurewebsites.net/api/phinterface/balance`,
      referrals: `https://nitrogen-eus-stg-meta-support.azurewebsites.net/api/referrals`,
      stores: `${baseUrlStg}/stores?client=NITROGEN`,
      branches: `${baseUrlStg}/branches?client=NITROGEN`,
      geoProvinces: `${baseUrlStg}/geo/provinces?client=NITROGEN`,
      geoRegions: `${baseUrlStg}/geo/regions?client=NITROGEN`,
      geoCities: `${baseUrlStg}/geo/cities?client=NITROGEN`,
    });
  } else {
    return (config = {
      transactions: `https://nitrogen-eus-prod-transactions.azurewebsites.net/api`,
      invalidTypes: `https://nitrogen-eus-prod-transactions.azurewebsites.net/api/invalid-types?`,
      products: `https://nitrogen-eus-prod-products.azurewebsites.net/api/products`,
      skus: `https://nitrogen-eus-prod-products.azurewebsites.net/api/skus`,
      users: `https://nitrogen-eus-prod-users.azurewebsites.net/api/users`,
      raffle: `https://nitrogen-eus-prod-raffle.azurewebsites.net/api/draw`,
      winners: `https://nitrogen-eus-prod-raffle.azurewebsites.net/api/winners`,
      prep: `https://nitrogen-eus-prod-raffle.azurewebsites.net/api/prep`,
      login: `https://nitrogen-eus-prod-accounts.azurewebsites.net/api/login`,
      accounts: `https://nitrogen-eus-prod-accounts.azurewebsites.net/api/accounts`,
      txnstats: `https://nitrogen-eus-prod-stats.azurewebsites.net/api/stats`,
      productstats: `https://nitrogen-eus-prod-itemstats.azurewebsites.net/api/itemstats`,
      responder: `https://nitrogen-eus-prod-responder.azurewebsites.net/api/responder`,
      fraud: `https://nitrogen-eus-prod-transactions.azurewebsites.net/api/fraud/duplicate`,
      export: `https://nitrogen-eus-prod-exporter.azurewebsites.net/api/export/weekly`,
      redeem: `https://nitrogen-eus-prod-redeem.azurewebsites.net/api/redeemhistory`,
      gCashBalance: `https://nitrogen-eus-prod-redeem.azurewebsites.net/api/phinterface/balance`,
      referrals: `https://nitrogen-eus-prod-meta-support.azurewebsites.net/api/referrals`,
      stores: `${baseUrlProd}/stores?client=NITROGEN`,
      branches: `${baseUrlProd}/branches?client=NITROGEN`,
      geoProvinces: `${baseUrlProd}/geo/provinces?client=NITROGEN`,
      geoRegions: `${baseUrlProd}/geo/regions?client=NITROGEN`,
      geoCities: `${baseUrlProd}/geo/cities?client=NITROGEN`,
    });
  }
};

export const config = configFunction("prod");

export const FETCH_BRANCH_CONFIG = {
  page: 1,
  perPage: 10000,
  disabled: 0,
};

export const FETCH_SKU_CONFIG = {
  page: 1,
  limit: 10000,
  disabled: 0,
};

export const FETCH_PRODUCTS_CONFIG = {
  page: 1,
  limit: 10000,
  disabled: false,
};

export const LOCATION_AUTH = {
  headers: {
    Authorization: ".~UDw?<M=UEUN$rX_F^C-ax,G088bAj2u<~",
  },
};
